<mat-dialog-title style="padding: 8px 12px;">
  <div class="dialog-title-container">
    <h2 class="title">New Application</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon class="close-icon">close</mat-icon>
    </button>
  </div>
</mat-dialog-title>

<mat-dialog-content class="dialog-container">
  <div class="content">
    <p>Please select which Merck product you would like to apply for below:</p>

    <p class="label">Merck Product:</p>
    <mat-form-field appearance="outline" class="dropdown">
      <mat-label>Drug Name</mat-label>
      <mat-select [(ngModel)]="selectedOption">
        <mat-option *ngFor="let drug of drugList" value={{drug.drugID}}>
          {{ drug.drugName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="actions">
      <button  class="button-Primary" (click)="confirm()">APPLY</button>
    </div>
  </div>
</mat-dialog-content>